'use memo';

import React from 'react';
import { AgxLegalDescription } from '@urbanx/agx.ui-components2';
import { LegalDescriptionModel } from '@urbanx/agx.campaigns.client';

interface LegalDescriptionProps {
  id: string;
  label?: string;
  readonly?: boolean;
  onChange: (change: { id: string; value: LegalDescriptionModel }) => void;
  legalDescription: LegalDescriptionModel;
  required?: boolean;
  validate?: boolean;
}

const LegalDescription: React.FC<LegalDescriptionProps> = ({
  id,
  label,
  readonly,
  onChange,
  legalDescription,
  required,
  validate,
}) => {
  const onChangeParcel = (index: number, newParcel: any) => {
    if (!legalDescription?.parcels) return;

    const updatedParcels = [...legalDescription.parcels];
    updatedParcels[index] = newParcel;

    const updatedLegalDescription = {
      ...legalDescription,
      parcels: updatedParcels,
    };

    onChange({ id, value: updatedLegalDescription });
  };

  const onRemoveParcel = (index: number) => {
    if (!legalDescription?.parcels) return;

    const updatedParcels = legalDescription.parcels.filter((_, i) => i !== index);

    const updatedLegalDescription = {
      ...legalDescription,
      parcels: updatedParcels,
    };

    onChange({ id, value: updatedLegalDescription });
  };

  const onAddNewParcel = () => {
    const newParcel = {
      lotNumber: '',
      planType: '',
      planNumber: '',
      titleReference: '',
      isPrimaryPlan: false,
    };

    const updatedParcels = [...(legalDescription?.parcels || []), newParcel];

    const updatedLegalDescription = {
      ...legalDescription,
      parcels: updatedParcels,
    };

    onChange({ id, value: updatedLegalDescription });
  };

  return (
    <AgxLegalDescription
      id={id}
      label={label}
      readonly={readonly}
      legalDescription={legalDescription}
      onChangeParcel={onChangeParcel}
      onRemoveParcel={onRemoveParcel}
      onAddNewParcel={onAddNewParcel}
      required={required}
      validate={validate}
    />
  );
};

export default LegalDescription;
